import { sectionRenderer } from '@theme/section-renderer';

class CartAbOffer extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-cart-ab-action]')?.addEventListener('click', this.onAction);
  }

  disconnectedCallback() {
    this.querySelector('[data-cart-ab-action]')?.removeEventListener('click', this.onAction);
  }

  onAction = async () => {
    const button = this.querySelector('[data-cart-ab-action]');
    const select = this.querySelector('[data-variant-select]');
    const errorElement = this.querySelector('[data-error]');
    if (!(button instanceof HTMLButtonElement) || !(select instanceof HTMLSelectElement)) return;

    this.setAttribute('aria-busy', 'true');
    button.disabled = true;
    if (errorElement instanceof HTMLElement) errorElement.hidden = true;

    try {
      const quantity = Number(this.dataset.quantity || 1);
      const isUpgrade = button.dataset.cartAbAction === 'upgrade';
      const itemToAdd = { id: Number(select.value), quantity };
      if (isUpgrade) itemToAdd.properties = { _cart_upgrade: 'true' };

      const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [itemToAdd] }),
      });
      if (!addResponse.ok) throw new Error((await addResponse.json()).description || 'Unable to add this product.');

      if (isUpgrade) {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!cartResponse.ok) throw new Error('The new product was added, but the cart could not be read.');
        const updatedCart = await cartResponse.json();
        const oldVariantId = Number(this.dataset.oldVariantId);
        const originalLineIndex = updatedCart.items.findIndex(
          (item) =>
            item.key === this.dataset.oldKey ||
            (item.variant_id === oldVariantId && item.properties?._cart_upgrade !== 'true')
        );
        if (originalLineIndex < 0) throw new Error('The new product was added, but the original product could not be located.');

        const changeResponse = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: originalLineIndex + 1, quantity: 0 }),
        });
        const changeData = await changeResponse.json();
        if (!changeResponse.ok) throw new Error(changeData.description || 'The original product could not be removed.');
      }

      const sectionIds = [
        ...new Set(
          [...document.querySelectorAll('cart-items-component[data-section-id]')]
            .map((element) => element.dataset.sectionId)
            .filter(Boolean)
        ),
      ];
      await Promise.all(
        sectionIds.map((sectionId) => sectionRenderer.renderSection(sectionId, { cache: false, mode: 'hydration' }))
      );
    } catch (error) {
      if (errorElement instanceof HTMLElement) {
        errorElement.textContent = error instanceof Error ? error.message : 'Something went wrong. Please try again.';
        errorElement.hidden = false;
      }
    } finally {
      this.removeAttribute('aria-busy');
      button.disabled = false;
    }
  };
}

if (!customElements.get('cart-ab-offer')) customElements.define('cart-ab-offer', CartAbOffer);
